import { inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationStart, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { ReceiveNotificationMessage } from './signal-r.service';

@Injectable({
  providedIn: 'root',
})
export class SignalrNotificationService {
  private readonly router = inject(Router);

  private subject = new Subject<ReceiveNotificationMessage | undefined>();
  private keepAfterRouteChange = true;

  constructor() {
    // clear alert messages on route change unless 'keepAfterRouteChange' flag is true
    this.router.events.pipe(takeUntilDestroyed()).subscribe((event): void => {
      if (event instanceof NavigationStart) {
        if (this.keepAfterRouteChange) {
          // Keep only for a single route change
          this.keepAfterRouteChange = false;
        } else {
          this.clear();
        }
      }
    });
  }

  /** Get observable for notifications */
  getAlert(): Observable<ReceiveNotificationMessage | undefined> {
    return this.subject.asObservable();
  }

  /** Push a new notification */
  showNotification(
    message: string,
    shortMessage: string,
    id?: string,
    keepAfterRouteChange = false,
  ): void {
    this.keepAfterRouteChange = keepAfterRouteChange;
    this.subject.next({
      Id: id || Math.random().toString(36).substring(2, 9),
      ShortMessage: shortMessage,
      Title: message,
    } as ReceiveNotificationMessage);
  }

  /** Clear notifications */
  clear(): void {
    this.subject.next(undefined);
  }
}
